export function error(state, error) {
  state.errorMsg = error.message
}


export function setChildrenDate(state, data) {
  state.childrenData = data
  let formated = []
  state.childrenData.filter(child => child.child_enabled).forEach(element => {
    formated.push({
      value: element.id,
      text: element.name
    })
  });
  state.childrenDataFormatted = formated
}

export function cleanErrors(state) {
  state.errors = ""
}

export function setGoalsSetup(state, data) {
  state.dailyGoal = data
}

export function setChildrenOrder(state, data) {
  state.childrenOrder = data
}

export function setChildChallengeOrder(state, data) {
  state.childChallengeOrder = data
}

export function setFavoriteSkills(state, data) {
  state.favoriteSkills = data
}

export function setChildsCliniciansReport(state, data) {
  state.childsCliniciansReport = data
}